<template>
  <vs-row class="my-5">
    <vs-col>
      <h6 class="font-bold mb-4">{{ $t('filters.' + filter.title + '.title') }}</h6>
      <div>
        <ul>
          <li
            v-for="dateRange in filter.dateRanges"
            :key="dateRange.value"
            class="flex items-center cursor-pointer py-1"
            @click="onSelect(dateRange)">

            <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-success fill-current': dateRange.selected}, 'h-5 w-5']"/>
            <span class="ml-2" :class="{'text-success': dateRange.selected}">{{ $t('filters.' + filter.title + '.values.' + dateRange.label) }}</span>
          </li>
        </ul>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'sm-hateoas-filter-date-range',
  props: {
    filter: Object,
    default () {
      return {
        id: null,
        title: null,
        dateRanges: []
      };
    }
  },
  mounted () {
    this.$emit('change', this.buildValue(this.filter.dateRanges.find(dr => dr.selected)));
  },
  methods: {
    onSelect (dateRange) {
      this.filter.dateRanges.forEach(dr => {
        dr.selected = false;
      });
      dateRange.selected = true;
      this.$forceUpdate();
      const newValue = this.buildValue(dateRange);
      this.$emit('change', newValue);
    },
    buildValue (dateRange) {
      return dateRange.from || dateRange.to ? `${dateRange.from || ''}|${dateRange.to || ''}` : '';
    }
  }
};
</script>

<style scoped>

</style>
